import { defineMessages } from 'react-intl';

export default {
  pages: {
    landing: {
      startEarning: {
        livejasmin: {
          ...defineMessages({
            title: {
              id: 'pages.landing.startEarning.livejasmin.title',
              defaultMessage: 'How to start <b>earning</b>',
            },
            description1: {
              id: 'pages.landing.startEarning.livejasmin.description1',
              defaultMessage: 'You bring the talent, we bring the traffic.',
            },
            description2: {
              id: 'pages.landing.startEarning.livejasmin.description2',
              defaultMessage: 'All you need is a device and your best smile.',
            },
            description3: {
              id: 'pages.landing.startEarning.livejasmin.description3',
              defaultMessage: 'Explore our features & start earning now!',
            },
          }),
          slides: defineMessages({
            privateAndVipShows: {
              id: 'pages.landing.startEarning.livejasmin.slides.privateAndVipShows',
              defaultMessage: 'Private and VIP Shows',
            },
            messenger: {
              id: 'pages.landing.startEarning.livejasmin.slides.messenger',
              defaultMessage: 'Messenger',
            },
            photosAndVideos: {
              id: 'pages.landing.startEarning.livejasmin.slides.photosAndVideos',
              defaultMessage: 'Photos & Videos',
            },
            videoCall: {
              id: 'pages.landing.startEarning.livejasmin.slides.videoCall',
              defaultMessage: 'Video Call',
            },
            interactiveToy: {
              id: 'pages.landing.startEarning.livejasmin.slides.interactiveToy',
              defaultMessage: 'Interactive Toy',
            },
          }),
        },
      },
    },
  },
};
